import React from 'react';
import '../App.css'; // Archivo de estilos

import instagran1 from '../img/carrusel28.jpg'; // Importa tu imagen
import instagran2 from '../img/carrusel29.jpg'; // Importa más imágenes
import instagran3 from '../img/carrusel19.webp'; // Importa más imágenes
import instagran4 from '../img/carrusel30.jpg'; // Importa más imágenes
import instagran5 from '../img/carrusel31.jpg'; // Importa más imágenes
import instagran6 from '../img/carrusel32.jpg'; // Importa más imágenes
import instagran7 from '../img/carrusel33.jpg'; // Importa más imágenes
import instagran8 from '../img/carrusel34.jpg'; // Importa más imágenes
import instagran9 from '../img/carrusel35.jpg'; // Importa más imágenes
import instagran10 from '../img/carrusel36.jpg'; // Importa más imágenes
import instagran11 from '../img/carrusel37.jpg'; // Importa más imágenes
import instagran12 from '../img/carrusel38.jpg'; // Importa más imágenes
import instagran13 from '../img/carrusel39.jpg'; // Importa más imágenes
import instagran14 from '../img/carrusel40.jpg'; // Importa más imágenes
import instagran15 from '../img/carrusel41.jpg'; // Importa más imágenes
import instagran16 from '../img/carrusel42.jpg'; // Importa más imágenes

import instagran17 from '../img/carrusel43.jpg'; // Importa más imágenes
import instagran18 from '../img/carrusel46.jpg'; // Importa más imágenes
import instagran19 from '../img/carrusel47.jpg'; // Importa más imágenes
import instagran20 from '../img/carrusel50.jpg'; // Importa más imágenes
import instagran21 from '../img/carrusel51.jpg'; // Importa más imágenes
import instagran22 from '../img/carrusel52.jpg'; // Importa más imágenes
import instagran23 from '../img/carrusel53.jpg'; // Importa más imágenes
import instagran24 from '../img/carrusel59.jpg'; // Importa más imágenes
import instagran25 from '../img/carrusel60.jpg'; // Importa más imágenes
import instagran26 from '../img/carrusel61.jpg'; // Importa más imágenes
import instagran27 from '../img/carrusel62.jpg'; // Importa más imágenes
import instagran28 from '../img/carrusel63.jpg'; // Importa más imágenes
import instagran29 from '../img/carrusel64.jpg'; // Importa más imágenes
import instagran30 from '../img/carrusel65.jpg'; // Importa más imágenes
import instagran31 from '../img/carrusel67.jpg'; // Importa más imágenes
import instagran32 from '../img/carrusel70.jpg'; // Importa más imágenes
import instagran33 from '../img/carrusel71.jpg'; // Importa más imágenes
import instagran34 from '../img/carrusel72.jpg'; // Importa más imágenes
import instagran35 from '../img/carrusel73.jpg'; // Importa más imágenes
import instagran36 from '../img/carrusel74.jpg'; // Importa más imágenes
import instagran37 from '../img/carrusel75.jpg'; // Importa más imágenes
import instagran38 from '../img/carrusel76.jpg'; // Importa más imágenes
import instagran39 from '../img/carrusel78.jpg'; // Importa más imágenes
import instagran40 from '../img/carrusel79.jpg'; // Importa más imágenes
import instagran41 from '../img/carrusel80.jpg'; // Importa más imágenes
import instagran42 from '../img/carrusel81.jpg'; // Importa más imágenes
import instagran43 from '../img/carrusel85.jpg'; // Importa más imágenes
import instagran44 from '../img/carrusel86.jpg'; // Importa más imágenes
import instagran45 from '../img/carrusel87.jpg'; // Importa más imágenes
import instagran46 from '../img/carrusel88.jpg'; // Importa más imágenes
import instagran47 from '../img/carrusel89.jpg'; // Importa más imágenes
import instagran48 from '../img/carrusel93.jpg'; // Importa más imágenes
import instagran49 from '../img/carrusel94.jpg'; // Importa más imágenes

class InstagramGallery extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            photos: [




                {
                url: 'https://www.instagram.com/p/DPCWs3xkfOB/',
                 imageUrl: instagran49, // Otra imagen importada
                },


                {
                url: 'https://www.instagram.com/p/DPAQ91dERbl/',
                 imageUrl: instagran48, // Otra imagen importada
                },



            {
                url: 'https://www.instagram.com/p/DOvy5N3Ecjm/',
                 imageUrl: instagran47, // Otra imagen importada
                },

                {
                url: 'https://www.instagram.com/p/DOWg_BEkWuL/',
                 imageUrl: instagran46, // Otra imagen importada
                },

                {
                url: 'https://www.instagram.com/p/DOJ6f_PEVKH/',
                 imageUrl: instagran45, // Otra imagen importada
                },
             
                {
                url: 'https://www.instagram.com/p/DNRFCXexlN7/',
                 imageUrl: instagran44, // Otra imagen importada
                },

                {
                url: 'https://www.instagram.com/p/DNRExToRZVj/',
                 imageUrl: instagran43, // Otra imagen importada
                },



                {
                url: 'https://www.instagram.com/p/DM8gq3Bx2kA/',
                 imageUrl: instagran42, // Otra imagen importada
                },

                {
                url: 'https://www.instagram.com/p/DM8XSbjOqkx/',
                 imageUrl: instagran41, // Otra imagen importada
                },

                {
                url: 'https://www.instagram.com/p/DMylOKURBqs/',
                 imageUrl: instagran40, // Otra imagen importada
                },


                {
                url: 'https://www.instagram.com/p/DMykvFfxYRW/',
                 imageUrl: instagran39, // Otra imagen importada
                },

                {
                url: 'https://www.instagram.com/p/DMverbrOPv8/',
                 imageUrl: instagran38, // Otra imagen importada
                },

                  {
                url: 'https://www.instagram.com/p/DMoI6K7xYTs/',
                 imageUrl: instagran37, // Otra imagen importada
                },


                  {
                url: 'https://www.instagram.com/p/DMiV8a_M_1F/',
                 imageUrl: instagran36, // Otra imagen importada
                },



                  {
                url: 'https://www.instagram.com/p/DL-fFs3sBoF/',
                 imageUrl: instagran35, // Otra imagen importada
                },


                {
                url: 'https://www.instagram.com/p/DL7-1FxOXeA/',
                 imageUrl: instagran34, // Otra imagen importada
                },


                {
                url: 'https://www.instagram.com/p/DL5x_VXxNlg/',
                 imageUrl: instagran33, // Otra imagen importada
                },



                {
                    url: 'https://www.instagram.com/p/DK2TV2TsKEO/',
                    imageUrl: instagran32, // Otra imagen importada
                },


                
                {
                    url: 'https://www.instagram.com/p/DK2Al_iRNMW/',
                    imageUrl: instagran30, // Otra imagen importada
                },


                {
                    url: 'https://www.instagram.com/p/DKsVIuIyBVU/',
                    imageUrl: instagran31, // Otra imagen importada
                },


                {
                    url: 'https://www.instagram.com/p/DKAGOryNmiG/',
                    imageUrl: instagran29, // Otra imagen importada
                },

                {
                    url: 'https://www.instagram.com/p/DJ_8j_UtwHF/',
                    imageUrl: instagran28, // Otra imagen importada
                },

            {
                    url: ' https://www.instagram.com/p/DJ418Fiy6MF/',
                    imageUrl: instagran27, // Otra imagen importada
                },



               {
                    url: 'https://www.instagram.com/p/DJ2RzqASOxR/',
                    imageUrl: instagran26, // Otra imagen importada
                },


                {
                    url: 'https://www.instagram.com/p/DJpTJjYyGxg/',
                    imageUrl: instagran25, // Otra imagen importada
                },


                {
                    url: 'https://www.instagram.com/p/DJkItUrSQE6/',
                    imageUrl: instagran24, // Otra imagen importada
                },


                {
                    url: 'https://www.instagram.com/p/DI2BtHXuTew/',
                    imageUrl: instagran23, // Otra imagen importada
                },


            

                {
                    url: 'https://www.instagram.com/p/DIt6elvuKEb/',
                    imageUrl: instagran22, // Otra imagen importada
                },



                {
                    url: 'https://www.instagram.com/p/DIj530BSWgV/',
                    imageUrl: instagran21, // Otra imagen importada
                },
          

                {
                    url: 'https://www.instagram.com/p/DIBvb0UMhFn/',
                    imageUrl: instagran20, // Otra imagen importada
                },

                
                {
                    url: 'https://www.instagram.com/p/DGx9XzvupL-/',
                    imageUrl: instagran19, // Otra imagen importada
                },

                {
                    url: 'https://www.instagram.com/share/p/BAHPFQ0iof/',
                    imageUrl: instagran18, // Otra imagen importada
                },
                {
                    url: 'https://www.instagram.com/share/p/_brqDDBS9/',
                    imageUrl: instagran17, // Otra imagen importada
                },



                {
                    url: 'https://www.instagram.com/share/p/BAEZz4QlI9/',
                    imageUrl: instagran16, // Otra imagen importada
                },

                {
                    url: 'https://www.instagram.com/share/p/BAMCamjqQl/',
                    imageUrl: instagran15, // Otra imagen importada
                },

                
                        
                {
                  url: 'https://www.instagram.com/nuevazelandiaescuela/p/DDW4KICuOep/',
                  imageUrl: instagran14, // Otra imagen importada
                },


                {
                    url: 'https://www.instagram.com/p/DCzh2X7Ravk/',
                    imageUrl: instagran13, // Otra imagen importada
                },




                {
                    url: 'https://www.instagram.com/p/DChibvfPj8n/', // Link a Instagram
                    imageUrl: instagran1, // Imagen importada
                },
                {
                    url: 'https://www.instagram.com/p/DCZ50beykXf/',
                    imageUrl: instagran2, // Otra imagen importada
                },
                {
                    url: 'https://www.instagram.com/p/DChiGIVREhg/',
                    imageUrl: instagran3, // Otra imagen importada
                },
                {
                    url: 'https://www.instagram.com/p/DCZ64JZSVoo/',
                    imageUrl: instagran4, // Otra imagen importada
                },
                {
                    url: 'https://www.instagram.com/p/DB9UAJJRtZk/',
                    imageUrl: instagran5, // Otra imagen importada
                },
                {
                    url: 'https://www.instagram.com/p/DBOmmnbu0bW/',
                    imageUrl: instagran6, // Otra imagen importada
                },
                {
                    url: 'https://www.instagram.com/p/DBJ_72Wyoxi/',
                    imageUrl: instagran7, // Otra imagen importada
                },
                {
                    url: 'https://www.instagram.com/p/C-3yDgGuOlb/',
                    imageUrl: instagran8, // Otra imagen importada
                },
                {
                    url: 'https://www.instagram.com/p/C-3xbqfuWnF/',
                    imageUrl: instagran9, // Otra imagen importada
                },
                {
                    url: 'https://www.instagram.com/p/C-Is9qsu6ug/',
                    imageUrl: instagran10, // Otra imagen importada
                },
                {
                    url: 'https://www.instagram.com/p/C-GVhE7S_ka/',
                    imageUrl: instagran11, // Otra imagen importada
                },
                {
                    url: 'https://www.instagram.com/p/C7zmZ2QpQ5l/',
                    imageUrl: instagran12, // Otra imagen importada
                },
               
            ],
        };
    }

    render() {
        const { photos } = this.state;

        return (
            <div className="Instagram-Galleria" id="Instagram-list">
                <h2 className="galeria-title">Galería Instagram</h2> {/* Título agregado */}
                <div className="photos-list">
                    <div className="photo-cards">
                        {photos.map((photo, index) => (
                            <div
                                key={index}
                                className="photo-card"
                                style={{
                                    backgroundImage: `url(${photo.imageUrl})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                }}
                            >
                                <a
                                    href={photo.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="photo-link"
                                >
                                    {/* Enlace al post de Instagram */}
                                </a>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    }
}

export default InstagramGallery;
